import { ARC_SERVICE } from "@/utils/services";

export const mspRoutes = {
  path: "/msp",
  component: () => import("@/layouts/Msp/MspLayout.vue"),
  children: [
    {
      path: "email_archiving",
      name: "msp-arc_titan",
      component: () => import("@/modules/ArcTitan/Views/Common"),
      meta: {
        solutionId: ARC_SERVICE,
      },
    },
  ],
};

export default {};
